define('app/sdc/collapse/sdc-collapse',["$animate", "$timeout"], function ($animate, $timeout) {
	var classes = {
		"collapsing": "sdc-collapsing",
		"collapse": "sdc-collapse",
		"in": "sdc-in"
	};
	return {
		restrict: "AE",
		scope: false,
		template: null,
		link: ["$element", "$attrs", "$scope", function ($element, $attrs, $scope) {
			var runningAnimation, _collapsed;
			function getAutoHeight() {
				var prevStyle = $element.attr("style"),
					newHeight;
				try {
					$element.css("height", "auto");
					newHeight = $element[0].scrollHeight + 'px';
				}
				finally {
					$element.attr("style", prevStyle);
				}
				return newHeight;
			}
			function cancelRunning() {
				if (runningAnimation) {
					console.debug("Cancelling running");
					$animate.cancel(runningAnimation);
					runningAnimation = false;
				}
			}
			function expand() {
				var callCount = 0;
				$element.removeClass(classes.collapse).addClass(classes.collapsing);
				cancelRunning();
				var thisAnimation = runningAnimation = $timeout(function () {
					var options = { to: { height: getAutoHeight() } };
					return $animate.addClass($element, classes.in, options);
				})
				thisAnimation.then(expandDone.bind(this, thisAnimation));
			}
			function expandDone(thisAnimation) {
				if (thisAnimation && runningAnimation !== thisAnimation) {
					return;
				}
				runningAnimation = null;
				$element.removeClass(classes.collapsing);
				$element.addClass(classes.in);
				$element.css("height", "auto");
			}


			function collapse() {
				// IMPORTANT: The height must be retrieved before adding "collapsing" class.
				// Otherwise, the browser attempts to animate from height 0 (in
				// collapsing class) to the given height here.
				var fromHeight = $element[0].scrollHeight + 'px';
				$element
				  .css("height", fromHeight)
				  // initially all panel collapse have the collapse class, this removal
				  // prevents the animation from jumping to collapsed state
				  .removeClass(classes.collapse)
				  .addClass(classes.collapsing);

				cancelRunning();
				var thisAnimation = runningAnimation = $animate.removeClass($element, classes.in, {
					to: { height: '0' }
				});
				thisAnimation.then(collapseDone.bind(this, thisAnimation));
			}
			function collapseDone(thisAnimation) {
				if (thisAnimation && runningAnimation !== thisAnimation) {
					return;
				}
				runningAnimation = null;
				$element.css("height", "0"); // Required so that collapse works when animation is disabled
				$element.removeClass(classes.collapsing + " " + classes.in);
				$element.addClass(classes.collapse);
			}

			$scope.$watch($attrs.sdcCollapse, function (shouldCollapse) {
				shouldCollapse = !!shouldCollapse;
				if (_collapsed === shouldCollapse) {
					return;
				}
				else if (_collapsed = shouldCollapse) {
					collapse();
				} else {
					expand();
				}
			});

			if (_collapsed = !!$scope.$eval($attrs.sdcCollapse)) {
				collapseDone();
			}
			else {
				expandDone();
			}
		}]
	};
});
